export { default as getId } from './get-id';
export { default as max } from './max';
export { default as min } from './min';
export { default as absMax } from './absMax';
export { default as Observer } from './observer';
export { default as style } from './style';
export { default as requestAnimationFrame } from './request-animation-frame';
export { default as frame } from './frame';
export { default as debounce } from 'debounce';
export { default as preventClick } from './prevent-click';
export { default as fetchFile } from './fetch';
export { default as clamp } from './clamp';
export { default as withOrientation } from './orientation';
export { default as ignoreSilenceMode } from './silence-mode';



// WEBPACK FOOTER //
// webpack://WaveSurfer/src/util/index.js